// LanguageSwitcher.js
import React from 'react'
import { useTranslation } from 'react-i18next'
import '../App.css'

function LanguageSwitcher() {
  const { i18n } = useTranslation()

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng)
  }

  return (
    <div className='langBar'>
      <p className='langBtn' onClick={() => changeLanguage('en')}>
        EN
      </p>
      |
      <p className='langBtn' onClick={() => changeLanguage('de')}>
        DE
      </p>
    </div>
  )
}

export default LanguageSwitcher
